import { useMemo } from 'react'

import { ColumnInstance } from 'react-table'

interface DefaultColumnFilterProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper column type
  column: ColumnInstance<any> & {
    filterValue?: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper preFilteredRows type
    preFilteredRows: any[]
    setFilter: (value: string | undefined) => void
  }
}

export function DefaultColumnFilter({
  column: { filterValue, setFilter },
}: DefaultColumnFilterProps) {
  return (
    <input
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
      }}
      placeholder={`Search records...`}
    />
  )
}

interface SelectColumnFilterProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper column type
  column: ColumnInstance<any> & {
    filterValue?: string
    setFilter: (value: string | undefined) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper preFilteredRows element type
    preFilteredRows: any[]
    id: string
  }
}

export function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}: SelectColumnFilterProps) {
  const options = useMemo(() => {
    const optionsSet = new Set<string | number>()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper row type
    preFilteredRows.forEach((row: any) => {
      const value = row.values[id]
      if (value != null) {
        optionsSet.add(value)
      }
    })
    return Array.from(optionsSet.values())
  }, [id, preFilteredRows])

  return (
    <select
      value={filterValue}
      onChange={e => {
        setFilter(e.target.value || undefined)
      }}
    >
      <option value="">All</option>
      {options.map((option, i) => (
        <option key={i} value={String(option)}>
          {String(option)}
        </option>
      ))}
    </select>
  )
}
